// «الجرد الشهري» strings (count screens). Merged into translations by i18n.js.
// Keys are stk_*; both languages must carry the same key set.
// `{name}` tokens are filled with `fmt()` from ./scUtils (t() has no interpolation).
export const STK_COUNT = {
    ar: {
        // hub section + shell
        stk_subtitle: "جرد المخزون في نهاية كل شهر للفروع والمستودعات، وتقييمه بالريال",
        stk_tab_count: "الجرد",
        stk_tab_board: "المتابعة",
        stk_tab_items: "الأصناف",
        stk_tab_costs: "التكاليف",
        stk_tab_setup: "الإعدادات",
        stk_loading: "جارٍ التحميل...",
        stk_not_ready: "تعذر فتح الجرد الشهري الآن. حاول مرة أخرى",
        stk_no_location: "لم يُحدَّد لك موقع جرد. تواصل مع مدير النظام",

        // pickers + window
        stk_select_location: "اختر الموقع",
        stk_kind_warehouse: "مستودع",
        stk_inactive: "غير نشط",
        stk_window_open: "جرد شهر {period} · يغلق {end}",
        stk_window_next: "يبدأ الجرد القادم ({period}) في {start}",
        stk_reopened_notice: "أعادت المالية فتح جرد {period} لـ«{location}» حتى {until}",
        stk_reopened_open: "فتح",

        // why the sheet is or is not editable (one per sc_core.edit_state reason)
        stk_reason_open: "فترة الجرد مفتوحة حتى {end}",
        stk_reason_reopened: "أعادت المالية فتح الجرد حتى {until}",
        stk_reason_finance: "تعدّل بصلاحية المالية، في أي وقت",
        stk_reason_read_only: "للاطلاع فقط: لا تملك صلاحية تسجيل الجرد",
        stk_reason_inactive: "هذا الموقع غير نشط، والجرد للاطلاع فقط",
        stk_reason_future: "لا يمكن جرد شهر لم يأتِ بعد",
        stk_reason_approved: "الجرد معتمد من المالية ولا يمكن تعديله",
        stk_reason_submitted: "تم إرسال الجرد. للتعديل اطلب من المالية إعادة فتحه",
        stk_reason_not_yet: "يبدأ جرد هذا الشهر في {start}",
        stk_reason_closed: "انتهت فترة جرد هذا الشهر. للتعديل اطلب من المالية إعادة فتحه",
        stk_stamp_saved: "آخر حفظ: {by}",
        stk_stamp_submitted: "أرسله: {by}",
        stk_stamp_approved: "اعتمده: {by}",

        // drafts
        stk_draft_restored: "استرجعنا تعديلاتك غير المحفوظة على هذا الجهاز",
        stk_draft_locked: "لديك {n} تعديل غير محفوظ، ولا يمكن حفظه الآن",

        // list
        stk_search: "ابحث باسم الصنف أو الكود",
        stk_uncounted_only: "غير المجرود فقط",
        stk_all_groups: "كل المجموعات",
        stk_no_group: "بدون مجموعة",
        stk_no_items: "لا توجد أصناف تُجرد في هذا الموقع",
        stk_no_match: "لا توجد أصناف مطابقة",
        stk_all_counted: "تم جرد كل الأصناف",
        stk_qty_placeholder: "—",
        stk_packs: "عبوات",
        stk_loose: "مفتوح",
        stk_pack_hint: "{pack} = {n} {unit}",
        stk_not_counted_short: "لم يُجرد",
        stk_no_cost: "لا توجد تكلفة لهذا الصنف",
        stk_unit_cost: "{cost} ر.س / {unit}",

        // bar + save
        stk_items_suffix: "صنف",
        stk_total_value: "القيمة",
        stk_missing_cost_n: "{n} بلا تكلفة",
        stk_unsaved_n: "{n} غير محفوظ",
        stk_save: "حفظ",
        stk_saving: "جارٍ الحفظ...",
        stk_saved_n: "تم حفظ {n} صنف",
        stk_nothing_changed: "لا توجد تعديلات للحفظ",
        stk_offline_error: "تعذر الاتصال — تحقق من الإنترنت ثم أعد المحاولة",
        stk_offline_not_saved: "لم يتم الحفظ — تحقق من الاتصال. تعديلاتك باقية على هذا الجهاز",
        stk_retry: "إعادة المحاولة",

        // submit
        stk_submit: "إرسال الجرد",
        stk_submit_title: "إرسال الجرد",
        stk_submit_body: "بعد الإرسال يُقفل الجرد، ولا يُعدَّل إلا إذا أعادت المالية فتحه.",
        stk_submit_missing: "بقي {n} صنف بلا جرد",
        stk_zero_fill: "اعتبرها صفراً",
        stk_zero_fill_hint: "تُسجَّل الأصناف غير المجرودة بكمية صفر",
        stk_submit_complete: "كل الأصناف مجرودة",
        stk_submit_confirm: "إرسال",
        stk_submitting: "جارٍ الإرسال...",
        stk_submitted: "تم إرسال الجرد",
        stk_cancel: "إلغاء",
    },
    en: {
        // hub section + shell
        stk_subtitle: "Month-end stock count for branches and warehouses, valued in riyals",
        stk_tab_count: "Count",
        stk_tab_board: "Board",
        stk_tab_items: "Items",
        stk_tab_costs: "Costs",
        stk_tab_setup: "Setup",
        stk_loading: "Loading...",
        stk_not_ready: "The stock count cannot be opened right now. Try again",
        stk_no_location: "No stock-count location is assigned to you. Contact the administrator",

        // pickers + window
        stk_select_location: "Select a location",
        stk_kind_warehouse: "Warehouse",
        stk_inactive: "Inactive",
        stk_window_open: "{period} count · closes {end}",
        stk_window_next: "The next count ({period}) opens on {start}",
        stk_reopened_notice: "Finance reopened the {period} count for {location} until {until}",
        stk_reopened_open: "Open",

        // why the sheet is or is not editable (one per sc_core.edit_state reason)
        stk_reason_open: "The count window is open until {end}",
        stk_reason_reopened: "Finance reopened this count until {until}",
        stk_reason_finance: "You are editing with finance access, at any time",
        stk_reason_read_only: "View only: you do not have stock-count entry access",
        stk_reason_inactive: "This location is inactive; the count is view only",
        stk_reason_future: "A month that has not started cannot be counted",
        stk_reason_approved: "Finance approved this count; it cannot be changed",
        stk_reason_submitted: "This count was submitted. Ask finance to reopen it to make changes",
        stk_reason_not_yet: "This month's count opens on {start}",
        stk_reason_closed: "The count window for this month has closed. Ask finance to reopen it",
        stk_stamp_saved: "Last saved by {by}",
        stk_stamp_submitted: "Submitted by {by}",
        stk_stamp_approved: "Approved by {by}",

        // drafts
        stk_draft_restored: "Your unsaved changes on this device were restored",
        stk_draft_locked: "You have {n} unsaved changes that cannot be saved now",

        // list
        stk_search: "Search by item name or code",
        stk_uncounted_only: "Not counted only",
        stk_all_groups: "All groups",
        stk_no_group: "No group",
        stk_no_items: "No items are counted at this location",
        stk_no_match: "No matching items",
        stk_all_counted: "Every item is counted",
        stk_qty_placeholder: "—",
        stk_packs: "Packs",
        stk_loose: "Loose",
        stk_pack_hint: "1 {pack} = {n} {unit}",
        stk_not_counted_short: "Not counted",
        stk_no_cost: "No cost for this item",
        stk_unit_cost: "{cost} SAR / {unit}",

        // bar + save
        stk_items_suffix: "items",
        stk_total_value: "Value",
        stk_missing_cost_n: "{n} without cost",
        stk_unsaved_n: "{n} unsaved",
        stk_save: "Save",
        stk_saving: "Saving...",
        stk_saved_n: "Saved {n} items",
        stk_nothing_changed: "Nothing to save",
        stk_offline_error: "Could not connect — check the internet and try again",
        stk_offline_not_saved: "Not saved — check the connection. Your changes stay on this device",
        stk_retry: "Retry",

        // submit
        stk_submit: "Submit count",
        stk_submit_title: "Submit the count",
        stk_submit_body: "Once submitted the count is locked; only finance can reopen it.",
        stk_submit_missing: "{n} items are not counted yet",
        stk_zero_fill: "Count them as zero",
        stk_zero_fill_hint: "Uncounted items are recorded with quantity 0",
        stk_submit_complete: "Every item is counted",
        stk_submit_confirm: "Submit",
        stk_submitting: "Submitting...",
        stk_submitted: "Count submitted",
        stk_cancel: "Cancel",
    },
};
